import React, { useEffect } from "react";
import {

  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from "@chakra-ui/react";

import { useDispatch } from "react-redux";
import { addDashboardData } from "../../../../redux/DashboardSlice";
import { DashboardService } from "../../../../core/Services";
import DashboardTableAdminJobs from "./DashboardTableAdminJobs";
import DahsboardTableAdminTask from "./DahsboardTableAdminTask";



function DashboardTableAdminPage() {
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await DashboardService();
        dispatch(addDashboardData(data));
      } catch (error) {
        console.error("API Hatası:", error);
      }
    };

    fetchData();
  }, [dispatch]);


  return (
          <Tabs align="end" variant="enclosed">
            <TabList>
              <Tab>Görevlerim</Tab>
              <Tab>İşlerim</Tab>
            </TabList>
            <TabPanels>
              <TabPanel>
                <DahsboardTableAdminTask />
              </TabPanel>
              <TabPanel>
                <DashboardTableAdminJobs />
              </TabPanel>
            </TabPanels>
          </Tabs>
  );
}

export default DashboardTableAdminPage;
